import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number, currency: string = "EUR"): string {
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
}

export function getArtworkTitle(artwork: { title_it: string; title_en: string }, locale: string): string {
  void locale;
  return artwork.title_en || artwork.title_it;
}

export function getArtworkDescription(
  artwork: { description_it: string | null; description_en: string | null },
  locale: string
): string | null {
  return locale === "it" ? artwork.description_it : artwork.description_en;
}

export function getArtworkPreviewImage(artwork: { image_url: string | null; additional_images: string | null }): string {
  if (artwork.image_url) return artwork.image_url;
  try {
    const images = artwork.additional_images ? JSON.parse(artwork.additional_images) : [];
    if (Array.isArray(images)) {
      const firstImage = images.find((image): image is string => typeof image === "string" && image.length > 0);
      if (firstImage) return firstImage;
    }
  } catch {
    // Fall through to the site fallback for malformed legacy image data.
  }
  return "/images/hero-artwork-cropped.jpg";
}
